import { render } from "./MaterialRadio.vue?vue&type=template&id=87a37c02&scoped=true"
import script from "./MaterialRadio.vue?vue&type=script&lang=js"
export * from "./MaterialRadio.vue?vue&type=script&lang=js"

import "./MaterialRadio.vue?vue&type=style&index=0&id=87a37c02&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87a37c02"]])

export default __exports__